export function isUserAuthorized(userRoles) {
    let rolesAuthorizedForStudentProfile = [
        'ASSESSMENT_COORDINATOR', // District assessment coordinator
        'ADMINISTRATOR', // School administrator
        'SCHOOL_ASSESSMENT_COORDINATOR',
        'INSTRUCTIONAL_PROVIDER',
    ];

    let isAuthorized = false;
    if (userRoles && rolesAuthorizedForStudentProfile.some((role) => userRoles.includes(role))) {
        isAuthorized = true;
    }
    return isAuthorized;
}

/*
 * This function is used to log out a user and prompt them with the login screen. It is akin to clicking the 'Logout' button on the nav bar.
 * It differs from other uses of `window.location = '/auth/login'` in that it will log a logged in user out, whereas
 * the previous example will only redirect a logged in user to the reports home page.
 */
export function redirectUserToLogin() {
    window.location.replace(`${window.location.origin}/auth/login`);
}

export default {
    redirectUserToLogin,
    isUserAuthorized,
};
